import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// TypeScript requires an explicit type for `document.getElementById`
const rootElement = document.getElementById('root') as HTMLElement;

// Ensure rootElement is not null before creating the root
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
